module.exports = __webpack_public_path__ + "img/reload.510e0523.svg";